import type { BrandAppNews, BrandAppTabId } from './brandAppContract'
import { isValidHttpUrl } from './brandAppUrl'

export const NEWS_MAX_COUNT = 10
export const NEWS_TITLE_MAX_LENGTH = 80
export const NEWS_DESCRIPTION_MAX_LENGTH = 2000
export const NEWS_BUTTON_MAX_LENGTH = 40

export type NewsField = 'image' | 'title' | 'description' | 'ctaLabel' | 'destination'

const TAB_SCREENS: string[] = ['home', 'order', 'loyalty', 'stores']

export const isTabScreen = (screen: string): screen is BrandAppTabId => TAB_SCREENS.includes(screen)

export const newsErrors = (news: BrandAppNews, tabs: BrandAppTabId[]) => {
  const errors: Partial<Record<NewsField, string>> = {}
  if (!news.image) errors.image = 'imageRequired'
  if (!news.title.trim()) errors.title = 'titleRequired'
  else if (news.title.length > NEWS_TITLE_MAX_LENGTH) errors.title = 'titleTooLong'
  if (!news.description.trim()) errors.description = 'descriptionRequired'
  else if (news.description.length > NEWS_DESCRIPTION_MAX_LENGTH) errors.description = 'descriptionTooLong'
  if (!news.ctaLabel.trim()) errors.ctaLabel = 'buttonRequired'
  else if (news.ctaLabel.length > NEWS_BUTTON_MAX_LENGTH) errors.ctaLabel = 'buttonTooLong'
  if (news.ctaTarget.type === 'screen') {
    const target = news.ctaTarget
    if (target.screen === 'survey') {
      if (!target.surveyId) errors.destination = 'surveyRequired'
    } else if (isTabScreen(target.screen) && !tabs.includes(target.screen)) errors.destination = 'disabledScreen'
  } else if (!isValidHttpUrl(news.ctaTarget.url.trim())) errors.destination = 'invalidUrl'
  return errors
}

export const reorderNews = (news: BrandAppNews[], ids: string[]): BrandAppNews[] => {
  if (ids.length !== news.length || new Set(ids).size !== ids.length) return news
  const byId = new Map(news.map((item) => [item.id, item]))
  if (ids.some((id) => !byId.has(id))) return news
  return ids.flatMap((id) => {
    const item = byId.get(id)
    return item ? [item] : []
  })
}
